import React, { useState } from "react";
import { Button } from "@mui/material";
import { useDispatch } from "react-redux";

import { discountCodesActions } from "../../../../reducers/discountCodes";
import { useDiscountsContext } from "../../../../context";
import { APIDiscounts } from "../../../../api";
import { DiscountCodeState, DiscountCodesData } from "../../../../api/discounts/index.types";

interface IProps {
  isAvailableActions: boolean;
  discount: DiscountCodeState;
}
interface IActions {
  id: number;
}

const CodeActivationActionStatus = ({
  isAvailableActions,
  discount,
}: IProps): React.ReactElement => {
  const dispatch = useDispatch();
  const [isUpdating, setIsUpdating] = useState(false);
  const { sortBy, search, page, limit } = useDiscountsContext();

  const changeActivationStatus = async (id: number, accepted: boolean) => {
    setIsUpdating(true);
    try {
      const data = {
        code_id: id,
        accepted,
        limit,
        page,
        contains: search,
        sortBy,
        inactive: true,
        editableValueKeyName: "accepted",
      };

      const response = await APIDiscounts.discountCodeActivateRequest(data);
      const responseData: DiscountCodesData = response.data;

      dispatch(discountCodesActions.fetchSuccess(responseData));
    } catch (error) {
      console.error(error);
    } finally {
      setIsUpdating(false);
    }
  };

  const Actions = ({ id }: IActions) =>
    isAvailableActions ? (
      <>
        <Button
          disabled={isUpdating}
          sx={{ maxWidth: "75px" }}
          onClick={() => changeActivationStatus(id, true)}
          data-test="accept-button-code"
        >
          Accept
        </Button>

        <Button
          disabled={isUpdating}
          sx={{ maxWidth: "75px" }}
          color="secondary"
          onClick={() => changeActivationStatus(id, false)}
        >
          Decline
        </Button>
      </>
    ) : (
      <>Waiting for approval</>
    );

  const StatusIc = () =>
    discount.accepted ? <b style={{ color: "green" }}>✔</b> : <b style={{ color: "red" }}>✘</b>;
  const ContentStatus = () =>
    discount.accepted === null ? <Actions id={discount.id} /> : <StatusIc />;

  return (
    <td style={{ textAlign: "center" }}>
      <ContentStatus />
    </td>
  );
};

export default CodeActivationActionStatus;
